import _ from 'lodash';

/*
 */
export function preparePayload(rawData, fieldsToPersist) {
  if (!Array.isArray(rawData)) return;
  if (!Array.isArray(fieldsToPersist)) return;

  return rawData.map(data => {
    return _.pick(data, fieldsToPersist);
  });
}

export function itemIsAreadySelected({
  selected = {},
  toSelect = {},
  property = 'cdLinhaPermissionario',
}) {
  if (!selected[property] && !toSelect[property]) return false;
  return selected[property] === toSelect[property];
}
